/**
 * Created by staffanrantzow on 30/03/16.
 */

import Utils from 'frilans-finans/utils/utils';
import SSNValidator from 'validators/ssnvalidator';

var FieldValidator = {
  validate (props) {
    var type = props.validationType ? props.validationType : props.type;
    switch (type) {
      case 'text':
        return this.validateText(props);
      case 'email':
        return this.validateEmail(props);
      case 'number':
        return this.validateNumber(props);
      case 'decimal':
        return this.validateDecimal(props);
      case 'tel':
        return this.validateText(props);
      case 'personalNumber':
        return this.validatePersonalNumber(props);
      case 'clearingNumber':
        return this.validateClearingNumber(props);
      case 'accountNumber':
        return this.validateAccountNumber(props);
      case 'passwordRegistration':
        return this.validatePassword(props);
      case 'phoneNumberSwedish':
        return this.validatePhoneNumberSwedish(props);
      case 'einvoice':
        return this.validateEinvoiceAddress(props);
      default:
        return this.validateText(props);
    }
  },

  validatePhoneNumberSwedish (props) {
    var normalized = props.value.toString().replace('(0)', '').replace(/\D+/gi, '');
    var re = /^(07|467|\+467)(0|2|3|6|9)\d{7}$/;
    return re.test(normalized);
  },

  validatePassword (props) {
    var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])[\S ]{12,}$/;
    return re.test(props.value);
  },

  validateText (props) {
    if (props.required && (props.minLength > props.value.length) ||
        (props.maxLength !== 0 && props.maxLength < props.value.length)) {
      return false;
    } else {
      return true;
    }
  },

  validateEmail (props) {
    if (props.minLength === 0 && props.value.length === 0) {
      return true;
    }
    /*eslint-disable */
    var re = /^(([^<>()\[\]\\.,;:\s@"äöå]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([åäöa-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /*eslint-enable */
    return re.test(props.value.trim());
  },

  /**
   * Validate phone number that must have 10 characters and can have
   * a hyphen after the third.
   */
  validateTel (props) {
    /*eslint-disable */
    let re = /^\d{3}-?\d{7}$/;
    /*eslint-enable */

    return re.test(props.value);
  },

  validatePersonalNumber (props) {
    return props.value.replace(/\D+/g, '').length === 12 && SSNValidator.validateSSN(props.value);
  },

  validateNumber (props) {
    if ((props.value !== '' || props.required) && Utils.isInt(props.value) && props.minLength <= props.value.length) {
      return true;
    } else {
      return false;
    }
  },

  validateDecimal (props) {
    let re = /^\d+(?:\.\d{1,2})?$/;
    if ((props.value !== '' || props.required) && re.test(props.value) && props.minLength <= props.value.length) {
      return true;
    } else {
      return false;
    }
  },

  validateClearingNumber (props) {
    var re = /^[\d]{4}$/;
    return re.test(props.value);
  },

  validateAccountNumber (props) {
    var re = /\d/;
    return re.test(props.value);
  },

  validateEinvoiceAddress (props) {
    return Utils.isValidEinvoiceAddress(props.value);
  }
};

export default FieldValidator;



/** WEBPACK FOOTER **
 ** ./src/components/input-field/field-validator.js
 **/